export default class OpenItems {

    constructor()
    {
        this.notPaidInvoices = 0;
        this.amount = {
            numerator: 0,
            denominator: 1
        };
        this.currency = 'EUR';
    }

    static fromData(data)
    {
        if (!data) {
            return;
        }

        let openItems = new OpenItems();
        openItems.notPaidInvoices = data.notPaidInvoices;
        openItems.amount = data.amount;
        openItems.currency = data.currency;

        return openItems;
    }

}
